<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="closeDialog()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>
  <h3 class="cg-dialog__header">
    <span
      [innerHTML]="
        'dashboard.latestUpdateTile.newFeatureModal.header' | translate
      "
    ></span>
    <span class="cg-dialog__header_subhead">{{
      'dashboard.latestUpdateTile.newFeatureModal.subheader' | translate
    }}</span>
  </h3>

  <mat-dialog-content>
    <h4 class="cg-h4">
      {{ data.feature.title }}
    </h4>

    <div class="cg-margin-bottom-md cg-margin-top-md">
      <img
        *ngIf="data.feature.imgUrl"
        width="100%"
        alt="placholder"
        [attr.src]="data.feature.imgUrl"
      />
      <iframe
        *ngIf="data.feature.videoUrl"
        class="cg-borderless-iframe"
        width="100%"
        height="425"
        [src]="data.feature.videoUrl | safe: 'resourceUrl'"
        allowfullscreen
      ></iframe>
    </div>
    <div class="cg-margin-bottom-md" [innerHTML]="data.feature.content"></div>
  </mat-dialog-content>
  <div class="cg-button-group cg-margin-top-lg">
    <a
      *ngIf="data.feature.resourceLink"
      cignaButton="primary"
      target="resourcesWindow"
      [attr.href]="
        data.feature.path | resourceLink: { targetApp: 'both' } | async
      "
      >{{ data.feature.linkText }}
    </a>
    <a
      *ngIf="data.feature.appLink"
      cignaButton="primary"
      (click)="closeDialog()"
      [routerLink]="data.feature.path.replace('app', '')"
      >{{ data.feature.linkText }}
    </a>
    <a
      *ngIf="!data.feature.resourceLink && !data.feature.appLink"
      cignaButton="primary"
      target="_blank"
      [attr.href]="data.feature.path"
      >{{ data.feature.linkText }}
    </a>
    <button cignaButton="link" (click)="closeDialog()">Close</button>
  </div>
</div>
